// extracted by mini-css-extract-plugin
export default {"container":"styles_container__qLf+j","individual":"styles_individual__AfuJ3","business":"styles_business__0UqBC","example":"styles_example__22BUR"};